import RelationshipMetadata from "../../RelationshipMetadata";

class AdminWorkGroupAdminWorkGroupUserGroupRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminWorkGroupAdminWorkGroupUserGroupRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminWorkGroup";
        this.childEnterpriseComponent = "AdminWorkGroupUserGroup";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default AdminWorkGroupAdminWorkGroupUserGroupRelationshipMetadata;